import React from 'react';
import { DocPageLayout } from '../../components/DocPageLayout';
import { CodeBlock } from '../../components/CodeBlock';
export function SdkSessionPage() {
  return <DocPageLayout title="Session SDK" description="Client-side session management for secure payment data handling." breadcrumbs={[{
    label: 'API Reference',
    id: 'api-overview'
  }, {
    label: 'SDKs'
  }, {
    label: 'Session'
  }]} data-id="element-866">
      <p className="text-gray-700 mb-8" data-id="element-867">
        The Session SDK (PaymentSession.js) provides hosted input fields that
        securely collect card data directly from the payer's browser without the
        data touching your servers.
      </p>
      <h2 className="text-2xl font-bold text-gray-900 mt-6 mb-4" data-id="element-868">
        Installation
      </h2>
      <CodeBlock language="HTML" title="Script Include" code={`<script src="https://test-gateway.mastercard.com/form/version/100/merchant/{merchantId}/session.js"></script>`} data-id="element-869" />
      <h2 className="text-2xl font-bold text-gray-900 mt-10 mb-4" data-id="element-870">
        Configuration
      </h2>
      <CodeBlock language="JavaScript" title="PaymentSession.configure()" code={`PaymentSession.configure({
  session: "SESSION_ID",
  fields: {
    card: {
      number: "#card-number",
      securityCode: "#security-code",
      expiryMonth: "#expiry-month",
      expiryYear: "#expiry-year",
      nameOnCard: "#cardholder-name"
    }
  },
  frameEmbeddingMitigation: ["javascript"],
  callbacks: {
    initialized: function(response) {
      console.log("Session fields ready");
    },
    formSessionUpdate: function(response) {
      if (response.status === "ok") {
        console.log("Session updated:", response.session.id);
      }
    }
  }
});`} data-id="element-871" />
      <h2 className="text-2xl font-bold text-gray-900 mt-10 mb-4" data-id="element-872">Methods</h2>
      <div className="overflow-x-auto mb-8" data-id="element-873">
        <table className="w-full text-sm border border-gray-200 rounded-lg overflow-hidden" data-id="element-874">
          <thead data-id="element-875">
            <tr className="bg-gray-100" data-id="element-876">
              <th className="text-left px-4 py-3 font-semibold border-b" data-id="element-877">
                Method
              </th>
              <th className="text-left px-4 py-3 font-semibold border-b" data-id="element-878">
                Description
              </th>
            </tr>
          </thead>
          <tbody className="divide-y divide-gray-200" data-id="element-879">
            <tr data-id="element-880">
              <td className="px-4 py-3 font-mono text-xs" data-id="element-881">
                PaymentSession.configure(config)
              </td>
              <td className="px-4 py-3 text-gray-600" data-id="element-882">
                Initialize hosted fields with session and field selectors
              </td>
            </tr>
            <tr className="bg-gray-50" data-id="element-883">
              <td className="px-4 py-3 font-mono text-xs" data-id="element-884">
                PaymentSession.updateSessionFromForm(scope)
              </td>
              <td className="px-4 py-3 text-gray-600" data-id="element-885">
                Submit field data to update the session
              </td>
            </tr>
            <tr data-id="element-886">
              <td className="px-4 py-3 font-mono text-xs" data-id="element-887">
                PaymentSession.setFocus(field)
              </td>
              <td className="px-4 py-3 text-gray-600" data-id="element-888">
                Programmatically focus a hosted field
              </td>
            </tr>
            <tr className="bg-gray-50" data-id="element-889">
              <td className="px-4 py-3 font-mono text-xs" data-id="element-890">
                PaymentSession.setFieldStyle(field, css)
              </td>
              <td className="px-4 py-3 text-gray-600" data-id="element-891">
                Apply custom CSS styles to a hosted field
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </DocPageLayout>;
}